import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { OrderLine } from '@/types/order';
import { getStepName } from '@/utils/stepNames';

interface ErrorWarningIconProps {
  orderLine: OrderLine;
}

export const ErrorWarningIcon: React.FC<ErrorWarningIconProps> = ({ orderLine }) => {
  const { t } = useTranslation();
  
  // Don't show icon for normal order lines
  if (!orderLine.type || orderLine.type === 'normal') {
    return null;
  }

  const errorFrom = orderLine.error_from_step || 'unknown';
  const generalNote = orderLine.notes || '';
  const errorDetailNote = orderLine.currentStatus?.note || '';

  const tooltipContent = (
    <div className="text-xs space-y-1">
      <div className="font-semibold">{t('tooltips.rework.title')}</div>
      <div>{t('tooltips.rework.errorFromStep')}: {getStepName(errorFrom)}</div>
      {generalNote && (
        <div>{t('suppliers.fields.notes')}: {generalNote}</div>
      )}
      {errorDetailNote && (
        <div className="text-gray-200 mt-1 border-t border-gray-700 pt-1">
          Chi tiết lỗi: {errorDetailNote}
        </div>
      )}
    </div>
  );

  return (
    <div className="relative inline-block group">
      <AlertTriangle className="h-4 w-4 text-yellow-600 hover:text-yellow-700 cursor-help" />
      
      {/* Tooltip */}
      <div className="absolute bottom-full left-0 mb-2 px-3 py-2 bg-gray-900 text-white rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 min-w-max">
        {tooltipContent}
        <div className="absolute top-full left-4 transform -translate-x-1/2 -mt-1">
          <div className="border-4 border-transparent border-t-gray-900"></div>
        </div>
      </div>
    </div>
  );
};

export default ErrorWarningIcon;
